export default __webpack_public_path__ + "static/media/avatar8.d055075f.png";